import { Autocomplete, Box, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import ButtonCta1 from "../button/ButtonCta1";
import { BASE_URL, toastConfig } from "../../constants/constant";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setAddButtonDisabled,
  setButtonAction,
  setHeader,
  setUpdateButtonDisabled,
} from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import styles from "./CreatePackage.module.css";
import { getAllPackage, getReportMaster } from "../../reduxSlices/packageSlice";
import { getOrganisationMaster } from "../../reduxSlices/organisationSlice";
import ContentLoader from "../loader/ContentLoader";
import { CustomTextField } from "../../helpers/helper";

const service = new Service();

const CreatePackage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { packageId } = useParams();
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);

  const [packages, setPackages] = useState({
    packageName: "",
    reportDetails: [],
    organizations: null,
  });

  const buttonAction = useSelector((state) => state?.header?.buttonAction);
  const reportMaster = useSelector((state) => state?.package?.reportMaster);
  const organisationMaster = useSelector(
    (state) => state?.organization?.organisationMaster
  );
  const allPackage = useSelector((state) => state.package.allPackage);

  const [reportValue, setReportValue] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const areInputsFilled = () => {
    return (
      packages?.packageName?.trim() !== "" &&
      packages?.reportDetails?.length > 0
      // Object?.keys(packages?.organizations || {})?.length > 0
    );
  };
  const inputFilled = areInputsFilled();

  const handleInputFocus = () => {
    if (!packageId) return;
    console.log("User clicked on the input text.");
    dispatch(setUpdateButtonDisabled(inputFilled));
  };

  const getPackageData = async () => {
    const obj = {
      searchText: "",
      organization: [],
      report: [],
    };
    await dispatch(getAllPackage(obj));
  };

  useEffect(() => {
    if (!packageId) return;
    getPackageData();
  }, [packageId]);

  useEffect(() => {
    if (!allPackage && !packageId) return;
    if (allPackage && packageId) {
      const filterPackage = allPackage?.filter(
        (item) => item.packageId === packageId
      );
      console.log("filterPackage", filterPackage);
      filterPackage?.map((item) =>
        setPackages({
          packageName: item?.packageName,
          reportDetails: item?.reportsMaster,
          organizations: item?.organizations,
        })
      );
    }
  }, [packageId, allPackage]);

  useEffect(() => {
    console.log("reportDetails>>>>>", packages?.reportDetails);
    setReportValue(packages?.reportDetails);
  }, [packageId, packages?.reportDetails]);

  useEffect(() => {
    console.log("packages>>>>", packages);
  }, [packages]);

  useEffect(() => {
    console.log("inputFilled>>>>", inputFilled);
    if (!packageId) {
      dispatch(setAddButtonDisabled(inputFilled));
    } else {
      dispatch(setUpdateButtonDisabled(inputFilled));
    }
  }, [inputFilled]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: !packageId ? "add-package" : "edit-package",
        title: !packageId ? "Add Package" : "Update Package",
        subTitle: !packageId
          ? "Please fill all the mandatory details to add new package"
          : "Please update the details if there are any discrepancies",
      })
    );
    dispatch(getReportMaster());
    dispatch(getOrganisationMaster());
  }, []);

  useEffect(() => {
    if (
      (buttonAction.page === "add-package" && buttonAction.action === "add") ||
      (buttonAction.page.includes("edit-package") &&
        buttonAction.action === "update")
    ) {
      console.log("buttonAction called");
      handleSubmit();
    }
    if (
      (buttonAction.page === "add-package" &&
        buttonAction.action === "cancel") ||
      (buttonAction.page.includes("edit-package") &&
        buttonAction.action === "cancel")
    ) {
      console.log("buttonAction called");
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  useEffect(() => {
    console.log("getSelectedValue", reportValue, reportMaster);
  }, [reportValue, reportMaster]);

  const getSelectedValue = (e) => {
    console.log("eeeeee", findIntersection(e), e);
    if (reportValue && reportValue.length > 0 && findIntersection(e)) {
      let filterNetworks = reportValue.filter(
        (data) => data?.reportId != e?.reportId
      );

      setReportValue(filterNetworks);
      setPackages({ ...packages, reportDetails: [...filterNetworks] });
    } else {
      let arr = [...reportValue, e];

      setReportValue(arr);
      setPackages({ ...packages, reportDetails: [...arr] });
    }
    dispatch(setUpdateButtonDisabled(inputFilled));
  };

  const findIntersection = (item) => {
    return reportValue?.map((el) => el?.reportId)?.includes(item?.reportId);
  };

  const handleOrganizationChange = (e) => {
    const { name, value } = e.target;
    setPackages({ ...packages, [name]: value });
  };

  const handleAutoCompleteChange = (name, value) => {
    setPackages((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGoBack = () => {
    navigate(-1);
    setOpen(false);
  };

  const handleSubmit = () => {
    if (!packageId) {
      createPackage();
    } else {
      updatePackage();
    }
  };

  const createPackage = async () => {
    setLoader(true);
    let url = `/api/Package/AddPackage`;
    const user_token = localStorage.getItem("bb_access_token");
    const organisationData = prepareOrganisationData();
    const formData = JSON.stringify(organisationData);
    try {
      let data = await service.newPostApi(url, formData, user_token);
      let resp = data.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        setLoader(false);
        toast.success("New package has been added", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        navigate("/packages");
      } else {
        setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const updatePackage = async () => {
    if (packageId) {
      setLoader(true);
      let url = `/api/Package/UpdatePackage?packageId=${packageId}`;
      const user_token = localStorage.getItem("bb_access_token");
      const organisationData = prepareOrganisationData();
      const formData = JSON.stringify(organisationData);
      try {
        let data = await service.newPutApi(url, formData, user_token);
        let resp = data.data;
        console.log("resp", resp);
        if (resp?.data && resp?.success) {
          toast.success("Package details has been updated", {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          });
          navigate("/packages");
          setLoader(false);
        } else {
          setLoader(false);
          toast.warning(resp?.errorMessage, toastConfig);
        }
      } catch (err) {
        console.log(err);
        setLoader(false);
        toast.error(err?.message, toastConfig);
      }
    }
  };

  const prepareOrganisationData = () => {
    return {
      packageName: packages?.packageName,
      reportDetails: packages?.reportDetails,
      organizations: packages?.organizations ? packages?.organizations : [],
    };
  };

  const testPrepData = prepareOrganisationData();
  console.log("testPrepData", testPrepData);

  if (loader) return <ContentLoader />;

  return (
    <>
      <div
        style={{
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "0 32px 10px 0",
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { marginBottom: "20px" },
          }}
          noValidate
          autoComplete="off"
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              Name<sup style={requiredAr}>*</sup>
            </label>
            <CustomTextField
              placeholder="Enter the package name..."
              sx={{ width: "520px" }}
              id="outlined-basic"
              variant="outlined"
              type="text"
              name="packageName"
              value={packages?.packageName}
              onChange={handleOrganizationChange}
              onFocus={handleInputFocus}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={{ ...labelStyle, marginBottom: "20px" }}>
              Reports<sup style={requiredAr}>*</sup>
            </label>
            <div className={styles.container}>
              {reportMaster &&
                reportMaster?.map((item, i) => (
                  <div
                    key={i}
                    className={styles.child}
                    style={{
                      backgroundColor: findIntersection(item) ? "#56a5a1" : "",
                      border: findIntersection(item) ? "#56a5a1" : "",
                      color: findIntersection(item) ? "#fff" : "",
                    }}
                    onClick={() => getSelectedValue(item)}
                  >
                    {item?.reportName}
                  </div>
                ))}
            </div>
          </Box>
          {/* <Box sx={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>Organisation (Optional)</label>
            <Autocomplete
              sx={{ width: "520px" }}
              disablePortal
              id="combo-box-demo"
              options={organisationMaster}
              value={packages?.organizations || null}
              onChange={(e, value) =>
                handleAutoCompleteChange("organizations", value)
              }
              getOptionLabel={(option) => option?.organizationName || ""}
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  placeholder="Select organisation to assign..."
                  onFocus={handleInputFocus}
                />
              )}
            />
          </Box> */}
        </Box>
      </div>

      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default CreatePackage;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};
